export default function Datenschutz() {
  return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">Datenschutzerklärung</h1>
      <p>Diese Website verwendet keine Cookies und speichert keine personenbezogenen Daten.</p>
      <p className="mt-4 text-gray-600">
        Die endgültige Datenschutzerklärung wird in Kürze ergänzt.
      </p>
    </div>
  );
}
